var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"basic_wrap"},[_c('colorHeader',{attrs:{"radius":false,"kefu":true,"title":_vm.data.title}}),_c('div',{staticClass:"ctn"},[_c('div',{staticClass:"contract_box",domProps:{"innerHTML":_vm._s(_vm.data.content)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }